import React from 'react';
import Team from "../../../models/Team";
import {useProject} from "../../../providers/ClientProjectProvider";
import LoadingBanner from "../../../components/LoadingBanner";
import {Empty, Modal, Switch, Table} from "antd";
import ErrorBanner from "../../../components/ErrorBanner";
import {useNavigate, useSearchParams} from "react-router-dom";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import UserImageCircle from "../../../components/UserImageCircle";
import TeamMemberOppStatusTable from "../team-scope/TeamMemberOppStatusTable";
import TeamCandidateScopeProvider from "../team-scope/TeamCandidateScopeProvider";
import TeamConfirmPayoutForm from "../team-scope/TeamConfirmPayoutForm";
import {useAPI} from "../../../config/API";

const ProjectTeamsTable = () => {
    const {project, isProjectUpdating} = useProject();

    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const {
        data: teamMatches,
        isFetching,
        isInitialLoading: isLoading,
        isRefetching,
        error,
        refetch,
    } = useAPI(['teamMatches', {project: project.id, shortlisted: 1}],
         {
             select: data => {
                return TB.map(data.teams, team => Team.make(Team.normalizeScope(team, project)))
            },
        }
    );
    const updateTeam = async (record, props) => {
        let request = TB.request(`/api/job-candidates/teams/${record.job_candidate.id}/update-scope`, props)

        let response = await request.post().catch(console.warn);

        return TB.queryClient.invalidateQueries(['teamMatches', {project: project.id, shortlisted: 1}])
    }

    const columnWidths = {
        Team: 260,
        Type: 80,
        Scoping: 155,
        Status: 320,
        Payout: 245,
        Actions: 105,
    }
    return (
        <div>

            {isLoading ? (
                <LoadingBanner message="Loading Team Invites"/>
            ) : (error ? (
                <ErrorBanner/>
            ) : (
                teamMatches?.length > 0 ? (
                    <div className="relative w-full py-8">
                        <Table
                            rowKey="id"
                            dataSource={teamMatches}
                            bordered
                            size="middle"
                            scroll={{
                                x: TB.sum(TB.values(columnWidths)),
                            }}
                            pagination={false}>

                            {/*<Table.Column*/}
                            {/*    title={'Invited At'}*/}
                            {/*    dataIndex={'client_invited_at'}*/}
                            {/*    width={130}*/}
                            {/*    editable={false}*/}
                            {/*    render={(_, record) => {*/}
                            {/*        return (*/}
                            {/*            <p className="text-center text-xs whitespace-nowrap">*/}
                            {/*                {TB.moment(record.job_candidate?.talent_invited_at).fromNow()}*/}
                            {/*            </p>*/}
                            {/*        )*/}
                            {/*    }}*/}
                            {/*/>*/}

                            <Table.Column
                                title="Team"
                                dataIndex="name"
                                width={columnWidths.Team}
                                // fixed={"left"}
                                editable={false}
                                render={(_, record) => {
                                    let users = record.job_candidate?.talent_opps?.length ? TB.map(record.job_candidate.talent_opps, 'user') : (record.positions || [])
                                    return (
                                        <div className="flex flex-col gap-2">
                                            <div className="flex flex-row items-center gap-3">
                                                {/*<p className="text-sm font-semibold whitespace-nowrap">*/}
                                                {/*    {record.name}*/}
                                                {/*</p>*/}
                                                <p className="text-sm w-44 font-semibold whitespace-nowrap">
                                                    {record.name}
                                                </p>
                                                <div className="flex flex-row items-center">
                                                    {TB.map(TB.take(users, 3), position => (
                                                        <div className="ml-[-3px]"
                                                             key={`tp-${record.id}-${position.id}`}>
                                                            <UserImageCircle
                                                                user={position} size={28}
                                                                className="img-fluid img-grayscale border border-white"/>
                                                        </div>
                                                    ))}
                                                    {users.length > 3 && (
                                                        <div className="ml-[-3px]">
                                                            <div className="user-image-circle w-7 h-7 bg-blue-100">
                                                                <div className="initials text-info">
                                                                    + {users.length - 3}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }}
                            />
                            <Table.Column
                                title="Type"
                                dataIndex="type"
                                width={columnWidths.Type}
                                align="center"
                                editable={false}
                                render={type => {
                                    return (
                                        <p className="text-xxs text-secondary font-medium">
                                            {type}
                                        </p>
                                    )
                                }}
                            />

                            <Table.Column
                                title="Project Scoping"
                                align="center"
                                dataIndex="job_candidate.scope_confirmed_at"
                                width={columnWidths.Scoping}
                                editable={false}
                                render={(_, record) => {
                                    return (
                                        <div
                                            className={'flex flex-row items-center gap-1.5 pointer-events-none' + (!isProjectUpdating ? '' : 'pointer-events-none')}>
                                            <Switch
                                                size="small"
                                                className={record.hasConfirmedScope() ? 'bg-green-400' : ''}
                                                checkedChildren={<CheckOutlined/>}
                                                unCheckedChildren={<CloseOutlined/>}
                                                checked={record.hasConfirmedScope()}
                                                disabled={false}
                                                onChange={async (checked) => {

                                                    let updates = {scope_confirmed_at: !record.hasConfirmedScope() ? new Date() : null};
                                                    if (updates.scope_confirmed_at && !project.hasRequestedProjectScopeCall()) {

                                                        let confirm = await TB.alert('warning', 'Scope Call Not Requested Yet', 'The client has not requested a scope call yet. Are you sure you want to confirm the project scope and allow the client to invite teams?', [
                                                            {title: 'Yes, Continue'},
                                                            {title: 'Cancel'},
                                                        ]);

                                                        if (!confirm) {
                                                            return;
                                                        }
                                                        updates.scope_call_requested_at = new Date();
                                                    }

                                                    return updateTeam(record, updates)
                                                }}
                                            />
                                            <p className={TB.mapClass("whitespace-nowrap text-xs", {
                                                'font-semibold': !record.hasConfirmedScope()
                                            })}>
                                                {record.job_candidate?.has_confirmed_scope ? 'Complete' : 'Pending'}
                                            </p>
                                        </div>

                                    )
                                }}
                            />
                            <Table.Column
                                title="Member Status"
                                dataIndex="total_talent_opps"
                                width={columnWidths.Status}
                                editable={false}
                                render={(_, record, index) => {

                                    let totalSteps = record.total_talent_opps;
                                    let steps = [];
                                    TB.map(TB.range(record.total_accepted_talent_opps), result => {
                                        steps.push(TB.config('color.info'))
                                    })
                                    TB.map(TB.range(record.total_proposed_talent_opps), result => {
                                        steps.push(TB.config('color.warning'))
                                    })
                                    TB.map(TB.range(record.total_rejected_talent_opps), result => {
                                        steps.push(TB.config('color.danger'))
                                    })
                                    TB.map(TB.range(record.total_withdrawn_talent_opps), result => {
                                        steps.push(TB.config('color.danger-darker'))
                                    })
                                    TB.map(TB.range(record.total_pending_talent_opps), result => {
                                        steps.push(TB.config('color.gray'))
                                    })

                                    const totalAccepted = record.hasConfirmedPayout() ? totalSteps : (record.total_accepted_talent_opps + record.total_proposed_talent_opps)
                                    return (
                                        <React.Fragment key={record.id}>
                                            <div className="flex flex-row gap-1 items-center flex-nowrap">
                                                {steps?.length > 0 ? (
                                                    <React.Fragment>
                                                        {TB.map(steps, (step, ind) => {
                                                            const bgColor = record.hasConfirmedPayout() ? TB.config('color.success-dark') : step
                                                            return (
                                                                <div style={{background: bgColor}} key={ind}
                                                                     className="h-3 w-6"/>
                                                            )
                                                        })}

                                                        <p className="text-xxs whitespace-nowrap">
                                                            {`${totalAccepted} / ${totalSteps} accepted`}
                                                        </p>

                                                        <button
                                                            className="btn btn-link btn-link-primary ml-auto text-xs"
                                                            onClick={() => {
                                                                let params = new URLSearchParams(searchParams);
                                                                params.set('memberStatus', record.id)
                                                                return setSearchParams(params)
                                                            }}
                                                            disabled={isProjectUpdating}>
                                                            Details
                                                        </button>
                                                    </React.Fragment>
                                                ) : (
                                                    <p className="text-xs">
                                                        <i>Scoping Required</i>
                                                    </p>
                                                )}


                                            </div>
                                            <TeamCandidateScopeProvider team={record} project={project} isDisabled={isProjectUpdating}>
                                                <Modal
                                                    okText={"Close"}
                                                    cancelText={null}
                                                    title={(
                                                        <div className="flex flex-row items-center">
                                                            <p className="text-base">
                                                                {`Team Member Status for ${record.name}`}
                                                            </p>
                                                            <div className="flex flex-row ml-auto gap-14 mr-10">
                                                                <div className="flex flex-col gap-1.5 items-start">
                                                                    <p className="text-xs font-semibold">
                                                                        Team Total Hours
                                                                    </p>
                                                                    <p className="text-primary text-lg">
                                                                        {TB.sumBy(record.disciplines, 'total_proposed_team_hours')} hours
                                                                    </p>
                                                                </div>
                                                                {/*<div className="flex flex-col gap-1.5 items-start">*/}
                                                                {/*    <p className="text-xs font-semibold flex flex-row gap-1.5 items-center">*/}
                                                                {/*        <span>*/}
                                                                {/*            Team Estimated Market Cost*/}
                                                                {/*        </span>*/}
                                                                {/*    </p>*/}
                                                                {/*    <p className="text-primary text-lg">*/}
                                                                {/*        {TB.formatCurrency(TB.sumBy(TB.flatMap(record.job_candidate.talent_opps, 'disciplines'), 'payout_amount'))}*/}
                                                                {/*    </p>*/}
                                                                {/*</div>*/}
                                                                <div className="flex flex-col gap-1.5 items-start">
                                                                    <p className="text-xs font-semibold flex flex-row gap-1.5 items-center">
                                                                        <span>
                                                                            Estimated Team Payout
                                                                        </span>
                                                                    </p>
                                                                    <div className="flex flex-row items-center gap-4">

                                                                        <span
                                                                            className="text-primary text-lg">{TB.formatCurrency(TB.sumBy(record.disciplines, 'estimated_proposed_team_cost'), false)}</span>
                                                                        {/*<TeamConfirmPayoutForm buttonClass="btn-primary text-xxs"/>*/}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    className="project-scope-modal opp-status-modal"
                                                    open={searchParams.has('memberStatus') && searchParams.get('memberStatus') === String(record.id)}
                                                    closeable={false}
                                                    maskClosable={false}
                                                    style={{top: 20}}
                                                    okType="default"
                                                    // destroyOnClose={true}
                                                    cancelButtonProps={{style: {display: 'none'}}}
                                                    width={1600}
                                                    onOk={() => {
                                                        if (isProjectUpdating) {
                                                            return
                                                        }
                                                        let params = new URLSearchParams(searchParams);
                                                        params.delete('memberStatus')
                                                        return setSearchParams(params)
                                                    }}
                                                    confirmLoading={isProjectUpdating}
                                                    onCancel={() => {
                                                        if (isProjectUpdating) {
                                                            return
                                                        }
                                                        let params = new URLSearchParams(searchParams);
                                                        params.delete('memberStatus')
                                                        return setSearchParams(params)
                                                    }}
                                                >

                                                    <div className="px-6">
                                                        <TeamMemberOppStatusTable canEdit={false}/>
                                                    </div>
                                                </Modal>
                                            </TeamCandidateScopeProvider>
                                        </React.Fragment>
                                    )
                                }}
                            />
                            <Table.Column
                                title="Team Payout / Client Fee"
                                dataIndex="phases"
                                editable={false}
                                width={columnWidths.Payout}
                                render={(_, record, index) => {

                                    if (!record.hasConfirmedScope()) {
                                        return (
                                            <p className="text-xs">
                                                <i>Scoping Required</i>
                                            </p>
                                        )
                                    }

                                    return (
                                        <div className="flex flex-row gap-3 items-center">
                                            <p className="text-sm whitespace-nowrap">
                                                {record.job_candidate?.talent_opps?.length ? (
                                                    <React.Fragment>
                                                        {TB.formatCurrency(TB.sumBy(record.disciplines, 'estimated_proposed_team_cost'), false)}
                                                        &nbsp;/&nbsp;
                                                        {TB.formatCurrency(TB.sumBy(record.disciplines, 'estimated_proposed_platform_cost'), false)}
                                                    </React.Fragment>
                                                ) : 'Pending'}
                                            </p>
                                            <TeamCandidateScopeProvider
                                                team={record} project={project} isDisabled={isProjectUpdating}>
                                                <TeamConfirmPayoutForm/>
                                            </TeamCandidateScopeProvider>
                                        </div>
                                    )
                                }}
                            />
                            <Table.Column
                                title="Actions"
                                align="center"
                                dataIndex="operations"
                                width={columnWidths.Actions}
                                fixed="right"
                                render={(_, record) => {

                                    if (project.hasAssignedCandidates() && record.job_candidate?.id !== project.assigned_team_candidate?.job_candidate?.id) {
                                        return null;
                                    }
                                    return (
                                        <button className="btn btn-info text-xxs whitespace-nowrap py-1 px-1.5"
                                                disabled={isProjectUpdating}
                                                onClick={() => {
                                                    navigate(`${record.job_candidate?.id}`)
                                                }}>
                                            Manage Scope
                                        </button>
                                    )
                                }}
                            />
                        </Table>

                        <div className="mt-5 flex flex-col items-start justify-end gap-2">
                            <div className="flex flex-row items-center gap-1">
                                <div style={{background: TB.config('color.success-dark')}} className="h-3 w-6"/>
                                <p className="text-xs font-medium">
                                    Accepted (Team Payout confirmed and available to client)
                                </p>
                            </div>
                            <div className="flex flex-row items-center gap-1">
                                <div style={{background: TB.config('color.info')}} className="h-3 w-6"/>
                                <p className="text-xs font-medium">
                                    Accepted (Team Payout needs confirmation)
                                </p>
                            </div>
                            <div className="flex flex-row items-center gap-1">
                                <div style={{background: TB.config('color.warning')}} className="h-3 w-6"/>
                                <p className="text-xs font-medium">
                                    Accepted with proposed changes
                                </p>
                            </div>

                            <div className="flex flex-row items-center gap-1">
                                <div style={{background: TB.config('color.danger')}} className="h-3 w-6"/>
                                <p className="text-xs font-medium">
                                    Rejected
                                </p>
                            </div>
                            <div className="flex flex-row items-center gap-1">
                                <div style={{background: TB.config('color.danger-darker')}} className="h-3 w-6"/>
                                <p className="text-xs font-medium">
                                    Withdrew from opportunity
                                </p>
                            </div>
                            <div className="flex flex-row items-center gap-1">
                                <div style={{background: TB.config('color.gray')}} className="h-3 w-6"/>
                                <p className="text-xs font-medium">
                                    Notified, no response yet
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <Empty description="No teams have been invited by the client to propose"
                           image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                )
            ))}
        </div>
    );
};

export default ProjectTeamsTable;